import { useCallback } from "react";

import { useTranslation } from "react-i18next";

import {
    FEATURE_SETTINGS,
    FILE_TYPES,
    useCompanyLevelSettings
} from "../../../../../shared";
import { DropdownValue } from "../../types";

export const useDisabled = () => {
    const { t } = useTranslation();
    const { isFeatureSettingsRestricted } = useCompanyLevelSettings();

    const getTooltipTitle = (company: DropdownValue | null) => {
        if (isRestricted) {
            return t(`Restrictions##general message`);
        }

        return !company
            ? t("Dialog##field disabled until company selected")
            : "";
    };

    const getMissingFileTooltipTitle = useCallback(
        (dropdownFileType: FILE_TYPES) => {
            const tooltipTitleMain = t("Dialog##no dropdown files##main", {
                fileName: t(
                    `Dialog##no dropdown files##file names##${dropdownFileType}`
                )
            });

            const tooltipTitleDescription = t(
                "Dialog##no dropdown files##description",
                {
                    fileName: t(
                        `Dialog##no dropdown files##file names##${dropdownFileType}`
                    )
                }
            );

            return `${tooltipTitleMain} ${tooltipTitleDescription}`;
        },
        [t]
    );

    const isRestricted = isFeatureSettingsRestricted(
        FEATURE_SETTINGS.SmartDeviceGroupSupport
    );

    return { isRestricted, getTooltipTitle, getMissingFileTooltipTitle };
};
